import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createLeave, fetchMyAttendance } from "../../../service/api";


export const getParentChildAttendance = createAsyncThunk(
    "parentChild/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchMyAttendance(params)
            console.log("attendance", response)
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message)
        }
    }
)


const parentChildSlice = createSlice({
    name: "parentChildAttendance",
    initialState: {
        childAttendance: [],
        childLeave: [],
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        limit: 10,
        searchParams: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            //GET
            .addCase(getParentChildAttendance.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getParentChildAttendance.fulfilled, (state, action) => {
                state.isLoading = false;

                const params = action.meta.arg; // 👈 access params
                console.log("params fullfill", params)
                if (params === "Attendance") {
                    state.childAttendance = action.payload.data;
                } else {
                    state.childLeave = action.payload.data;
                }
            })
            .addCase(getParentChildAttendance.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

    }
})
export default parentChildSlice.reducer;